import { render } from "./MultipaneContainer.vue?vue&type=template&id=7081d9d8"
import script from "./MultipaneContainer.vue?vue&type=script&lang=js"
export * from "./MultipaneContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__